module.exports = __webpack_public_path__ + "media/images/sp/resort_plans/slider_button_prev-fa969c3b8812c99060983687b9fcb1fa.svg";